/**
 * Created by huc on 11/03/2019.
 */
import { Model }            from 'backbone';
import contentTemplate from 'designer/mobile-menu.ejs';
import LayoutMenuView from 'LayoutMenuView.js';
import formSaveService from 'FormSaveService.js';
import notificationService from 'NotificationService.js';
import undoService      from 'UndoService.js';
import util              from 'util/Util';
import eventBus from '../service/EventBus';
import constants from '../constants/Constants';
import listService from 'ListService';
import mobileMargin from '../mobile/commons/MobileMargins'
import MobileConfirmationModal    from 'dashboard/forms/modal/MobileConfirmationModal';
import mobileConstants from '../mobile/commons/MobileFormsConstants';
import mobileListService from '../service/mobile/MobileListService';
import formService from 'FormService';


//=================================================================================================
//
// An instance forms BackBone view of the menubar used atop the report panel.
// It specializes the menu template.
//
// Lou Mauget, September 20, 2016
//
//=================================================================================================
class MobileMenuView extends LayoutMenuView {

    initialize( opts ) {
        super.initialize( opts );
        this.template = contentTemplate;

        // Replace form save event handlers with report save handlers.
        this.events = Object.assign( this.events, {
            'click #designerSave'           : 'saveForm',
            'click #designerSaveNewVersion' : 'saveFormNewVersion',
            'click #designerSaveNewForm'    : 'saveFormAsNew',
            'click #designerPreview'        : 'preview',
            'click #designerDebug'        : 'debug',
            'click #pf-close-main-view':'closeForm',
            'click .margin-optionButton': 'setMargin',
            'click #mobileFormatMenu': 'initializeMargins',
            'click #resetMobile': 'resetMobile'
        });

        eventBus.on('selectRightMarginOption', this.addSelectClassToMenu);

        return this;
    }

    initializeMargins(){
        if (listService.selected.size > 0 && listService.selected.first()){
            $('#mobile-margins').removeClass("pf-disable");
            //let mobileObject = listService.getMobileObject(selectedItemId);
            this.addSelectClassToMenu();

        }
        else{
            $('#mobile-margins').addClass("pf-disable")
        }       
    }

    addSelectClassToMenu() {

        if (listService.selected.size) {
            let selectedItemId = listService.selected.first().id;
            let mobileObject = mobileListService.getMobileControl(selectedItemId);
            const margins = mobileObject.model.get('margins');
            let selectedOption = mobileMargin.getSelectedOption({margins: Object.assign({}, margins)}, 5);
            $(".margin-optionButton").removeClass("selected");
            $(`svg[data-margin=${selectedOption}]`).addClass("selected");

            console.log("svg", $(`svg[data-margin=${selectedOption}]`));
        }
    }



    setMargin(ev){
        eventBus.trigger(constants.EV_UPDATE_MARGIN, ev.currentTarget);
    }

    resetMobile(ev){

        new MobileConfirmationModal( {
            model: new Model( {
                confirmationTitle: "Mobile Designer",
                confirmationText: mobileConstants.RESET_MOBILE_FORM,
                height: 180,
                width: 500,
                buttons : [
                    {
                        text: 'Yes',
                        resolve: "reset"
                    },
                    {
                        text: 'No',
                        resolve: "cancel"
                    }]
            })
        }).render().then(result => {
            if ('reset' === result) {
                this.resetCurrentMobileForm(ev);
            }         
        });
    }

    resetCurrentMobileForm(){       
        listService.removeAllObjectsFromSections();
        listService.removeAllSections();
        listService.deleteMobileColumns();
        listService.mobileSetWizardCompleted = false;
        listService.isMobileDirty = true;
        listService.resetCurrentMobileForm = true;

        listService.linkClicked = true;
        Backbone.history.loadUrl('edit');
    }

    closeForm(ev){
        if (undoService.hasChanges()) { 
            ev.preventDefault();
            ev.returnValue = false; 
            util.removeIfRemainingHelpCenter();                       
            formService.confirmSaveOnClose(); 
        }
        else {
            ev.preventDefault();
            ev.returnValue = false;              
            util.removeIfRemainingHelpCenter();    
            Backbone.history.loadUrl('close');
        }
    }




}

export default MobileMenuView;
